<template>
  <div>
    <b-card title="Update Merchant Settings">
      <b-overlay
        :show="loading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-form
          @submit.prevent
          @submit="setMerchantSetting"
        >
          <b-row>
            <b-card
              title="Merchant Type (Cash/Credit) Enable Setting"
            >
              <b-form-radio-group
                v-model="merchantType"
                :options="radioOptions"
                class="demo-inline-spacing"
                value-field="value"
                text-field="text"
                disabled-field="disabled"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              If this mode is on, the Merchant Type (Cash/Credit) Setting will be shown in both merchant and staff portal.
            </div>
          </b-row>
          <b-row>
            <b-card
              title="Merchant Pickup Request Enable Setting"
            >
              <b-form-radio-group
                v-model="pickupEnable"
                :options="radioOptions"
                class="demo-inline-spacing"
                value-field="value"
                text-field="text"
                disabled-field="disabled"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              When enabled, 'Merchant Pickup' is accessible in both merchant and staff portals. Disabling this option will set 'Merchant Pickup' to 'Disabled' for all clients. Please note that if there are any pending pickup requests with 'Pickup Request' enabled, they must be cleared before disabling this setting.
            </div>
          </b-row>
          <b-row>
            <b-card
              title="Order Exchange Block Setting"
            >
              <b-form-radio-group
                v-model="exchangeBlocked"
                :options="radioOptions"
                class="demo-inline-spacing"
                value-field="value"
                text-field="text"
                disabled-field="disabled"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              When enabled, Rider need to collect the return order from customer before exchange.
            </div>
          </b-row>
          <b-row>
            <b-card
              title="Merchant Verification Document Upload Settings"
            >
              <b-form-radio-group
                v-model="verifyDocUpload"
                :options="radioOptions"
                class="demo-inline-spacing mb-1"
                value-field="value"
                text-field="text"
                disabled-field="disabled"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              When this setting enabled, merchants will be REQUIRED to upload proof documents such as NIC, BR, Bank Detail Copy to the system during the registration process.
            </div>
          </b-row>
          <b-row>
            <!-- submit -->
            <b-col class="d-flex justify-content-end">
              <b-button
                v-can="'edit-merchant-setting'"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                class="mt-1 custom-button-color"
              >
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCard, BOverlay, BFormRadioGroup, BCol, BForm,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@core/mixins/filter'

const MerchantSettingsRepository = RepositoryFactory.get('merchantSetting')

export default {
  components: {
    BRow,
    BCard,
    BOverlay,
    BFormRadioGroup,
    BCol,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage, Filter],
  data() {
    return {
      dataLoading: false,
      loading: false,
      form: {},
      radioOptions: [
        { text: 'On', value: true },
        { text: 'Off', value: false },
      ],
      merchantType: false,
      pickupEnable: false,
      verifyDocUpload: false,
      exchangeBlocked: true,
    }
  },
  mounted() {
    this.readMerchantSetting()
  },
  methods: {
    async readMerchantSetting() {
      this.loading = true
      try {
        const { data } = (await MerchantSettingsRepository.getMerchantSettingsResource()).data
        this.form = data
        this.merchantType = this.form.merchant_type_select
        this.pickupEnable = this.form.merchant_pickup_enable
        this.verifyDocUpload = this.form.verify_document_upload_enable
        this.exchangeBlocked = this.form.block_exchange
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async setMerchantSetting() {
      this.loading = true
      // if (!this.pickupEnable) {
      //   await this.showMsgBox()
      // }
      try {
        // if (this.isDeliveryConfirmed === true || this.pickupEnable) {
        const payload = {
          merchant_type_select: this.merchantType,
          merchant_pickup_enable: this.pickupEnable,
          verify_document_upload_enable: this.verifyDocUpload,
          block_exchange: this.exchangeBlocked,
        }
        const res = await MerchantSettingsRepository.updateMerchantSettingsResource(payload)
        if (res.status === 200) {
          this.showSuccessMessage('Merchant Settings Updated Successfully')
        } else {
          this.showErrorMessage('Cannot Update Merchant Settings')
        }
        // }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.readMerchantSetting()
      this.loading = false
    },
    // async showMsgBox() {
    //   this.isDeliveryConfirmed = false
    //   const dialogText = 'When disabled, pickup requests will be automatically sent for orders with \'Pickup Request\' enabled.'
    //   return this.$swal({
    //     title: 'Are You Sure ?',
    //     text: dialogText,
    //     icon: 'info',
    //     showCancelButton: true,
    //     confirmButtonText: 'Yes, confirm!',
    //     cancelButtonText: 'No',
    //     customClass: {
    //       confirmButton: 'btn btn-primary',
    //       cancelButton: 'btn btn-outline-danger ml-1',
    //     },
    //     buttonsStyling: false,
    //     allowOutsideClick: false,
    //     backdrop: false,
    //   }).then(value => {
    //     this.isDeliveryConfirmed = value.isConfirmed
    //   })
    // },
  },
}
</script>
<style scoped>
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
.add-margin-bottom {
    margin-bottom: 20px;
}
@media (max-width: 767px) {
  .b-table thead th {
    position: sticky;
    top: 0;
  }
  .add-margin-bottom {
    width: 100%;
  }
}
</style>
